import { render, staticRenderFns } from "./ContentClassSelector.vue?vue&type=template&id=55a93c24&scoped=true&lang=html&"
import script from "./ContentClassSelector.vue?vue&type=script&lang=js&"
export * from "./ContentClassSelector.vue?vue&type=script&lang=js&"
import style0 from "./ContentClassSelector.vue?vue&type=style&index=0&id=55a93c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a93c24",
  null
  
)

export default component.exports